import L from 'leaflet';
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';

import TextLogo from '../../img/brand/fulllogo_nobuffer.png';
import './maps.css';

let DefaultIcon = L.icon({
  iconUrl:
    'https://api.golflists.com/storage/v1/object/public/map_icons/icons/basePin.png?t=2024-01-26T16%3A42%3A44.686Z',
  iconSize: [14, 14],
});
L.Marker.prototype.options.icon = DefaultIcon;

function MapLeafletErrorFallback() {
  return (
    <div
      className="max-h-[340px] lg:max-h-[345px] single-leaflet-container shadow-xl rounded-xl bg-gray-50 p-6 mt-1 text-center text-gray-600 text-sm"
      role="status"
    >
      Map could not be displayed. Location and course details are still listed
      above.
    </div>
  );
}

function LeafletCourseMap({ course }) {
  const lat = Number(course.latitude);
  const lng = Number(course.longitude);
  const marker =
    Number.isFinite(lat) &&
    Number.isFinite(lng) && (
      <Marker key={course.course_name} position={[lat, lng]}>
        <Popup>{course.course_name}</Popup>
      </Marker>
    );

  return (
    <div className="max-h-[340px] lg:max-h-[345px] single-leaflet-container shadow-xl rounded-xl bg-white p-2  mt-1">
      <div id="course-map" className="relative w-full h-full">
        <div className="absolute bottom-0 left-0 right-0 bg-white z-50">
          <h3 className="w-full px-5 mx-auto text-center text-lg font-semibold left-0 right-0">
            Course location
          </h3>
          <p className="w-full px-5 mx-auto text-center text-gray-700 text-xs italic left-0 right-0 ">
            Approximate position on the map (OpenStreetMap).
          </p>
        </div>
        <MapContainer
          center={[lat, lng]}
          zoom={5}
          scrollWheelZoom={true}
          style={{ width: '100%', height: '100%' }}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {marker}
        </MapContainer>
        <img
          loading="lazy"
          src={TextLogo}
          alt="Logo"
          className="absolute top-2 left-1/2 transform -translate-x-1/2 w-52 sm:w-56 border border-indigo-500 rounded-md px-4 py-2 bg-white z-30"
        />
      </div>
    </div>
  );
}

function SingleCourseMap({ course }) {
  if (!course) {
    return <div>No course data</div>;
  }

  const lat = Number(course.latitude);
  const lng = Number(course.longitude);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return (
      <div className="max-h-[120px] rounded-xl bg-gray-50 p-4 text-center text-gray-600 text-sm mt-1">
        No map coordinates for this course.
      </div>
    );
  }

  return (
    <ErrorBoundary FallbackComponent={MapLeafletErrorFallback}>
      <LeafletCourseMap course={course} />
    </ErrorBoundary>
  );
}

export default SingleCourseMap;
